/*
 *    Copyright [2007-2025] [wisemapping]
 *
 *   Licensed under WiseMapping Public License, Version 1.0 (the "License").
 *   It is basically the Apache License, Version 2.0 (the "License") plus the
 *   "powered by wisemapping" text requirement on every single page;
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the license at
 *
 *       https://github.com/wisemapping/wisemapping-open-source/blob/main/LICENSE.md
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

const IT = {
  LOADING: 'Caricamento ..',
  SAVING: 'Salvataggio ...',
  SAVE_COMPLETE: 'Salvataggio completato',
  ZOOM_IN_ERROR: 'Zoom troppo alto.',
  ZOOM_ERROR: 'Non è possibile applicare ulteriore zoom.',
  ONLY_ONE_TOPIC_MUST_BE_SELECTED: 'Impossibile creare un argomento. Deve essere selezionato solo un argomento.',
  ONE_TOPIC_MUST_BE_SELECTED: 'Impossibile creare un argomento. Deve essere selezionato un argomento.',
  ONLY_ONE_TOPIC_MUST_BE_SELECTED_COLLAPSE: 'I figli non possono essere compressi. Deve essere selezionato un argomento.',
  SAVE_COULD_NOT_BE_COMPLETED: 'Il salvataggio non può essere completato, riprova più tardi.',
  MAIN_TOPIC: 'Argomento Principale',
  SUB_TOPIC: 'Sotto Argomento',
  ISOLATED_TOPIC: 'Argomento Isolato',
  CENTRAL_TOPIC: 'Argomento Centrale',
  ENTITIES_COULD_NOT_BE_DELETED: 'Impossibile eliminare argomento o relazione. Almeno un\'entità della mappa deve essere selezionata.',
  CLIPBOARD_IS_EMPTY: 'Niente da copiare. Gli appunti sono vuoti.',
  CENTRAL_TOPIC_CAN_NOT_BE_DELETED: 'L\'argomento centrale non può essere eliminato.',
  RELATIONSHIP_COULD_NOT_BE_CREATED: 'La relazione non può essere creata. Deve essere selezionato prima un argomento padre.',
  SESSION_EXPIRED: 'La tua sessione è scaduta, per favore accedi di nuovo.',
  CENTRAL_TOPIC_CONNECTION_STYLE_CAN_NOT_BE_CHANGED: 'Lo stile di connessione non può essere cambiato per l\'argomento centrale.',
  CENTRAL_TOPIC_STYLE_CAN_NOT_BE_CHANGED: 'L\'argomento centrale non può essere cambiato in stile linea.',
  TAB_TO_CREATE_CHILD: 'per creare un figlio',
  ENTER_TO_CREATE_SIBLING: 'per creare un fratello',
  PLUS_TOOLTIP_CREATE_CHILD: 'Crea argomento figlio',
  PLUS_TOOLTIP_CREATE_SIBLING: 'Crea argomento fratello',
};

export default IT;
